import { Typography } from '@navi/web-ui/lib/primitives';
import { useState } from 'react';
import LoaderIcon from '@cp/src/assets/icons/LoaderIcon';
import { IFeedback, IFeedbackDetailsListProps } from '../interfaces';
import FeedbackAccordion from './FeedbackAccordion';

const FeedbackDetailsList = (props: IFeedbackDetailsListProps) => {
  const { addressText, feedbackList, showLoader } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpansion = (expanded: boolean) => {
    setIsExpanded(expanded);
  };

  if (showLoader) {
    return (
      <div className="h-full w-full bg-white top-0 flex items-center justify-center">
        <LoaderIcon
          size={40}
          borderWidth={4}
          borderColor="var(--navi-color-gray-border)"
          fillColor="var(--navi-color-blue-base)"
        />
      </div>
    );
  }
  return (
    <div className=" p-4 pr-5 box-border">
      <Typography variant="p5" color="var(--grayscale-content-2)">
        Feedback for
      </Typography>
      <Typography variant="p3" color="var(--grayscale-content-2)" className="break-words mt-1">
        {addressText}
      </Typography>
      <div className="mt-5">
        {feedbackList?.map((feedback: IFeedback) => (
          <FeedbackAccordion feedback={feedback} key={feedback?.referenceId} />
        ))}
      </div>
    </div>
  );
};

export default FeedbackDetailsList;
